/**
 * HE.Address
 * Various address functions
 */

(function Address($, HE)
{
	"use strict";

	var address = {};

	address.populateStates = function populateStates(country_id, $states_select) {
		HE.Ajax.get('/States/getByCountryId/' + country_id)
			.then(function _processAgentIds(data)
			{
				$states_select.empty();

				$states_select.append($('<option>').text('Please Select').attr('value', ''));

				$.each(data, function parseStates(sKey, sValue) {
					$states_select.append($('<option>').text(sValue).attr('value', sKey));
				});
			});
	};

	HE.Address = address;
}(jQuery, window.HE || {}));
